<template>
    <div style="background-color:#fff" >
      <van-sticky :offset-top="0 " >
        <mini_head_top> </mini_head_top>
      </van-sticky>
      <van-row  type="flex"  justify="space-between" style="margin: auto; padding: auto; margin-top: 10px; width: 100%;text-align: left">
        <van-row>
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">安全责任书</span>
        </van-row>
        <el-link style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-row >
      <div style="height:calc(80vh - 40px);overflow: auto;background-color: ghostwhite;">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for = " (item,index) in safeBookList" :key="item.id" style="margin: 10px; background-color: #fff;text-align: left;">
          <div style="padding: 1px;">  
            <div style=" padding:2px;text-align: right;">
              <!-- 并且自己考试时间用完 -->
              <el-tag  type = "warning" size="mini"  @click="viewSafeBookOne(item.id)"  
                v-if = "item.fileTreeId == null || item.fileTreeId == '' ">  
                去签名
              </el-tag >  
              <el-tag  v-else @click="viewSafeBookOne(item.id)"  
                size="mini" type = "success" > 
                查看签名
              </el-tag >
            </div>
            <div style="display: flex">
              <el-tag v-if = "item.fileTreeId == null || item.fileTreeId == ''"  effect="dark" size="mini" type="danger">未签名</el-tag>
              <el-tag   v-else effect="dark" size="mini" type="success">已签名</el-tag>
              <span style =" width: 80% ; overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"> {{ (index  + 1) + "."+ item.theme }}</span> 
            </div>
          </div>
          <div style="padding: 5px;font-size: 10px;">
            <span>发布时间: {{ item.sendTime }}</span>  
            <span v-if = "item.fileTreeId != null && item.fileTreeId != ''">签名时间: {{ item.signTime }}</span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
  </template>
  <script>
    import axios from  '@/api/axiosConfig'
    import mini_head_top from "@/mini_pages/mini_head_top"
    import logo from "@/assets/image/yuanhui.png"
    import {MESSAGE_DURATION } from  '@/api/constant'
    export default {
      name : 'mini_safe_book_list',
      data () {
        return {
          logo,
          theme:'',
          pageNo :0,
          totalPageSize : 0,
          type : "主题",
          safeBookList: [],
          loading: false,
          finished: false
        }
      },
      methods: {
        goHome(){
          this.$router.push({path:'/mini_index'})
        },
        viewSafeBookOne(id){
          this.$router.push( {path: '/mini_safe_book_editor', query: { id: id }})
        },
        onLoad() {
          setTimeout(() => {
            this.safeBookListLoad( (this.pageNo  + 1))
          }, 200)
        },
        safeBookListLoad(pageNo){
          
          let url = "/bc/exa/safeBook/selectUserSafeBookPage"
          let dat0 = {
            student:true,
            pageSize: 20,
            pageNo:pageNo,
            active : 1
          }
          axios.post(url, dat0).then((response) => {
            console.log(111111)
            this.pageNo = pageNo
            if (response.data.code === 0) {
              let dat = response.data.data
              if(dat.data.length !== 0){
                  if(pageNo == 1){
                    this.noticeList = [];
                  }
                  dat.data.forEach(t=>this.safeBookList.push(t))
                  if( dat.data.length < dat.pageSize ){
                    this.finished = true;
                  }
              } else {
                this.finished = true
                if(pageNo == 1){
                  this.$message({
                    showClose: true,
                    message: '未查询到安全责任书信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                  })
                }
              }

            }else{
              this.finished = true
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
            this.loading = false;
            }).catch((err)=>{
              //this.loading = false
              this.pageNo = pageNo -1
              this.loading = false;
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            });
        }

      },
      created(){
        //setTimeout(()=>{this.noticeListLoad(1),200})
      },
      components:{
        mini_head_top
      }
    }
  </script>
  
  <style lang="less" scoped>
      
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/mini_safe_book_list.vue